var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialAuthFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#858994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.666H22.25C21.2554 11.666 20.3016 12.105 19.5983 12.8864C18.8951 13.6678 18.5 14.7276 18.5 15.8327V18.3327H16.25V21.666H18.5V28.3327H21.5V21.666H23.75L24.5 18.3327H21.5V15.8327C21.5 15.6117 21.579 15.3997 21.7197 15.2434C21.8603 15.0871 22.0511 14.9993 22.25 14.9993H24.5V11.666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialAuthFacebook);
export default __webpack_public_path__ + "static/media/icon_social_auth_facebook.e8c72416ccb48982c7950d01b1f92b1b.svg";
export { ForwardRef as ReactComponent };